<template>
  <div class="layout">
    <!-- 页面内容区 -->
    <div class="page-content">
      <router-view />
    </div>

    <!-- 底部导航 -->
    <BottomTab 
      :key="$route.fullPath"
      :activeIndex="activeTab" 
      @tab-change="handleTabChange"
    />
  </div>
</template>

<script>
import BottomTab from '@/components/BottomTab.vue'

export default {
  name: 'Layout',
  components: { BottomTab },
  computed: {
    activeTab() {
      // 根据当前路由判断选中的tab
      const path = this.$route.path
      // 关键：所有 /apply 开头的子路由，都高亮第 1 项（申请加入）
      if (path.startsWith('/apply')) return 1
      if (path === '/home') return 0
      if (path === '/supply-demand') return 2
      if (path === '/mine') return 3
      return 0
    }
  },
  methods: {
    handleTabChange(index, path) {
      if (this.$route.path === path) return
      // 使用回调形式处理路由守卫重定向，避免产生未处理的 Promise rejection。
      this.$router.push(path, () => {}, () => {})
    }
  }
}
</script>

<style scoped>
.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
  /* 给底部导航留出空间，防止内容被挡住 */
  padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue